/* Generated by restful-react */

import React from "react";
import { Get, GetProps, useGet, UseGetProps } from "restful-react";

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export interface ArticleList {
  data: { id: number; title: string; content?: string; time_stamp: number }[];
  name?: string;
}

export interface Article {
  id: number;
  title: string;
  content?: string;
  time_stamp: number;
}

export interface NotificationList {
  data: { id: number; title: string; content?: string; time_stamp: number }[];
  name?: string;
}

export interface Notification {
  id: number;
  title: string;
  content?: string;
  time_stamp: number;
}

export interface Error {
  response_code?: number;
  info?: string;
}

export interface GetArticlesV1Response {
  data: { id: number; title: string; content?: string; time_stamp: number }[];
  name?: string;
}

export interface GetArticlesV1QueryParams {
  offset: number;
}

export type GetArticlesV1Props = Omit<
  GetProps<
    GetArticlesV1Response,
    { response_code?: number; info?: string },
    GetArticlesV1QueryParams
  >,
  "path"
>;

// 获取文章列表
export const GetArticlesV1 = (props: GetArticlesV1Props) => (
  <Get<
    GetArticlesV1Response,
    { response_code?: number; info?: string },
    GetArticlesV1QueryParams
  >
    path={`/articles`}
    {...props}
  />
);

export type UseGetArticlesV1Props = Omit<
  UseGetProps<GetArticlesV1Response, GetArticlesV1QueryParams>,
  "path"
>;

// 获取文章列表
export const useGetArticlesV1 = (props: UseGetArticlesV1Props) =>
  useGet<
    GetArticlesV1Response,
    { response_code?: number; info?: string },
    GetArticlesV1QueryParams
  >(`/articles`, props);

export interface GetNotificationsV1Response {
  data: { id: number; title: string; content?: string; time_stamp: number }[];
  name?: string;
}

export interface GetNotificationsV1QueryParams {
  offset: number;
}

export type GetNotificationsV1Props = Omit<
  GetProps<
    GetNotificationsV1Response,
    { response_code?: number; info?: string },
    GetNotificationsV1QueryParams
  >,
  "path"
>;

// 获取通知列表
export const GetNotificationsV1 = (props: GetNotificationsV1Props) => (
  <Get<
    GetNotificationsV1Response,
    { response_code?: number; info?: string },
    GetNotificationsV1QueryParams
  >
    path={`/notifications`}
    {...props}
  />
);

export type UseGetNotificationsV1Props = Omit<
  UseGetProps<GetNotificationsV1Response, GetNotificationsV1QueryParams>,
  "path"
>;

// 获取通知列表
export const useGetNotificationsV1 = (props: UseGetNotificationsV1Props) =>
  useGet<
    GetNotificationsV1Response,
    { response_code?: number; info?: string },
    GetNotificationsV1QueryParams
  >(`/notifications`, props);
